import PackService from '@/services/PackService'

const state = {
    all: {},
    grouped: {},
    plans: {},
    periods: [],
    selected: null,
    redeem: false,
    pack: {},
}

const actions = {
    fetch({ commit }, { platform, company_uuid, api_key, provider, cc, lang }) {
        const packService = new PackService(api_key)

        packService.get({
            platform,
            company_uuid,
            provider,
            cc,
            lang,
        })
            .then((response) => {
                commit('SET_KEYS', response.data)
                commit('UPDATE', response.data)
            })
            .catch((err) => console.log(err))
    },
    updatePrices({ commit }, plans) {
        const formatted = {}

        plans.forEach((plan) => {
            const key = plan.plan_sku
            const value = plan.plan_price

            formatted[key] = value
        })

        commit('UPDATE_PRICES', formatted)
    },
    select({ commit }, id) {
        commit('SELECT', id)
    },
    setPack({ commit }, id) {
        commit('SELECT_PACK', id)
    },
    reset({ commit }) {
        commit('SELECT', null)
        commit('SELECT_PACK', {})
    },
    redeem({ commit }, status) {
        commit('REDEEM', status)
    },
}

const mutations = {
    SELECT(state, id) {
        Object.assign(state, { selected: id })
    },
    REDEEM(state, status) {
        Object.assign(state, { redeem: status })
    },
    SELECT_PACK(state, pack) {
        Object.assign(state, { pack })
    },
    SET_KEYS(state, packs) {
        const keys = []

        Object.keys(packs)
            .forEach((period) => {
                const { period_key } = packs[period]

                keys.push({
                    label: period,
                    key: period_key,
                })
            })
        state.periods = keys
    },
    UPDATE_PRICES(state, plans) {
        state.plans = plans
    },
    UPDATE(state, packs) {
        const plans = [];

        Object.keys(packs)
            .forEach((period) => {
                const { entitlements } = packs[period]
                state.grouped[period] = entitlements

                entitlements.forEach((entitlement) => {
                    plans.push(entitlement)
                })
            })

        state.all = plans
    },
}

const getters = {
    all(state) {
        return state.all
    },
    selected(state) {
        return state.selected
    },
    redeemed(state) {
        return state.redeem
    },
    pack(state) {
        return state.pack
    },
    price(state, getters, rootState, rootGetters) {
        const { is_external } = rootGetters['providers/selected']
        const { cc } = rootGetters['settings/get']

        // eslint-disable-next-line func-names
        return function (plan) {
            if (!is_external && Object.keys(state.plans)
                .includes(plan.external_id)) {
                return state.plans[plan.external_id]
            }

            const sku = plan.prices.find((sku) => sku.country_code.toLowerCase() === cc.toLowerCase())

            return new Intl.NumberFormat(`en-${cc}`, {
                style: 'currency',
                currency: sku.currency_code,
                currencyDisplay: 'symbol',
            }).format(sku.price / 100)
        }
    },
    findPlan(state) {
        return function (externalId) {
            return state.pack.plans.find((plan) => plan.external_id === externalId)
        }
    },
}

export default {
    namespaced: true,
    state,
    actions,
    mutations,
    getters,
}
